module.exports = __webpack_public_path__ + "static/img/花瓶5.076b6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶5.png
// module id = c9Ki
// module chunks = 2